import OfferController from "./controllers/offer-controller";

export const showOfferPopup = () => {
  new OfferController({
    itemId: itemData.item_id,
    currentCity: shopInfoData.subdiv,
  }).show();
};
